"use client"

import { useState } from "react"
import "./OlvideContrasena.css"
import { useParams } from 'react-router-dom';
import { Navigate } from "react-router-dom";

import { GoogleReCaptchaProvider, useGoogleReCaptcha } from "react-google-recaptcha-v3";



const ForgotPassword = () => {
  const [username, setUsername] = useState("")
  const [userEmail, setUserEmail] = useState("")
  const [message, setMessage] = useState("")
  const [error, setError] = useState("")
  const [step, setStep] = useState(1)
  const [isLoading, setIsLoading] = useState(false)
  const [loadingProgress, setLoadingProgress] = useState(0)
  const { executeRecaptcha } = useGoogleReCaptcha();
  const { ambiente } = useParams();
  const tipoAmbiente = ambiente == "paco2" ? "2" : "3";

  if (ambiente !== "paco2" && ambiente !== "paco3") {
    return <Navigate to="/404" replace />;
  }

  const handleUsernameSubmit = async (e) => {
    e.preventDefault()
    setMessage("")
    setError("")
    setUserEmail("")
    setLoadingProgress(0) // Reset progress

    if (!username || username.trim() === "") {
      setError("Por favor, ingresa tu nombre de usuario.")
      return
    }

    if (!executeRecaptcha) {
      console.log("reCAPTCHA no esta listo todavia")
    }


    const tokenReCAPTCHA = await executeRecaptcha("submit");

    console.log("Token generado por reCAPTCHA")

    setIsLoading(true)

    // Simulate loading progress
    const progressInterval = setInterval(() => {
      setLoadingProgress((prev) => {
        if (prev >= 90) return prev // Stop at 90% 
        return prev + Math.random() * 15
      })
    }, 200)

    // Create AbortController for timeout
    const controller = new AbortController()
    const timeoutId = setTimeout(() => controller.abort(), 10000) // 10 seconds timeout

    try {
      // Call your API to check if the user exists
      const response = await fetch(
        `https://apps.paco.com.co/changePasswordPaco/changePasswordPaco2/userExist?option=${tipoAmbiente}&login=${username}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
          signal: controller.signal,
        },
      )

      clearTimeout(timeoutId)
      clearInterval(progressInterval)
      setLoadingProgress(100)

      if (response.ok) {
        const data = await response.text()
        if (data && data.includes("@")) {
          setUserEmail(data)
          setTimeout(() => setStep(2), 500) // Small delay to show 100% progress
        } else {
          setError("Usuario no encontrado o el correo no es válido. Por favor, verifica el nombre de usuario.")
        }
      } else {
        const errorText = await response.text()
        setError(errorText || "Usuario no encontrado. Por favor, verifica el nombre de usuario.")
      }
    } catch (err) {
      clearTimeout(timeoutId)
      clearInterval(progressInterval)
      console.error("Error al verificar el usuario:", err)

      // Check if it's a timeout error
      if (err.name === "AbortError") {
        setError("El servicio está tardando demasiado en responder. Por favor, inténtalo más tarde.")
      } else if (err.name === "TypeError" && err.message.includes("fetch")) {
        setError("Estamos experimentando problemas técnicos. Por favor, inténtalo más tarde.")
      } else if (err.message.includes("NetworkError") || err.message.includes("Failed to fetch")) {
        setError("Estamos experimentando problemas técnicos. Por favor, inténtalo más tarde.")
      } else if (err.code === "ECONNREFUSED" || err.message.includes("ECONNREFUSED")) {
        setError("Estamos experimentando problemas técnicos. Por favor, inténtalo más tarde.")
      } else {
        setError("Hubo un problema con la verificación. Por favor, comunícate con la línea de soporte.")
      }
    } finally {
      setIsLoading(false)
      clearInterval(progressInterval)
      setTimeout(() => setLoadingProgress(0), 1000) // Reset progress after delay
    }
  }

  const handleSendToken = async () => {
    setMessage("")
    setError("")
    setIsLoading(true)

    // Create AbortController for timeout
    const controller = new AbortController()
    const timeoutId = setTimeout(() => controller.abort(), 15000) // 15 ssegundos

    try {
      const response = await fetch(
        `https://apps.paco.com.co/changePasswordPaco/changePasswordPaco2/sendEmail?option=${tipoAmbiente}&login=${username}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
          signal: controller.signal,
        },
      )

      clearTimeout(timeoutId) // Clear timeout if request completes

      const data = await response.text()

      if (response.ok) {
        setMessage(`Se ha enviado un enlace de restablecimiento a ${data}. Por favor, revisa tu bandeja de entrada.`)
        setStep(3)
        setUsername("")
        setUserEmail("")
      } else {

        setError("Error al enviar el token de restablecimiento. Por favor, intenta de nuevo.")
      }
    } catch (err) {
      clearTimeout(timeoutId)
      console.error("Error al enviar el token:", err)

      // Check if it's a timeout error
      if (err.name === "AbortError") {
        setError("El envío del correo está tardando demasiado. Por favor, inténtalo más tarde.")
      } else if (err.name === "TypeError" && err.message.includes("fetch")) {
        setError("Estamos experimentando problemas técnicos. Por favor, inténtalo más tarde.")
      } else if (err.message.includes("NetworkError") || err.message.includes("Failed to fetch")) {
        setError("Estamos experimentando problemas técnicos. Por favor, inténtalo más tarde.")
      } else if (err.code === "ECONNREFUSED" || err.message.includes("ECONNREFUSED")) {
        setError("Estamos experimentando problemas técnicos. Por favor, inténtalo más tarde.")
      } else {
        setError("Hubo un problema con el envío del token. Por favor, comunícate con la línea de soporte.")
      }
    } finally {
      setIsLoading(false)
    }
  }

  const resetForm = () => {
    setStep(1)
    setMessage("")
    setError("")
    setUsername("")
    setUserEmail("")
  }

  const getProgressPercentage = () => {
    return (step / 3) * 100
  }

  const getStepInfo = () => {
    const steps = {
      1: { title: "Ingresa tu usuario", icon: "👤", description: "Buscaremos tu cuenta en nuestro sistema" },
      2: { title: "Confirma tu correo", icon: "📧", description: "Verificaremos tu dirección de correo electrónico" },
      3: { title: "Revisa tu email", icon: "✅", description: "Te hemos enviado las instrucciones" },
    }
    return steps[step] || steps[1]
  }

  const currentStep = getStepInfo()

  return (
    <div className="forgot-password-container">
      <div className="forgot-password-card">
        {/* Header con progreso */}
        <div className="card-header">
          <div className="step-icon">
            <span className="icon">{currentStep.icon}</span>
          </div>

          <h2>Restablece tu contraseña</h2>
          <p className="step-description">{currentStep.description}</p>

          {/* Barra de progreso */}
          <div className="progress-container">
            <div className="progress-bar">
              <div className="progress-fill" style={{ width: `${getProgressPercentage()}%` }}></div>
            </div>
            <div className="progress-steps">
              <span className={`step-number ${step >= 1 ? "active" : ""}`}>1</span>
              <span className={`step-number ${step >= 2 ? "active" : ""}`}>2</span>
              <span className={`step-number ${step >= 3 ? "active" : ""}`}>3</span>
            </div>
            <div className="step-labels">
              <span className={step >= 1 ? "active" : ""}>Usuario</span>
              <span className={step >= 2 ? "active" : ""}>Correo</span>
              <span className={step >= 3 ? "active" : ""}>Enviado</span>
            </div>
          </div>
        </div>

        <div className="card-content">
          {/* Paso 1: Ingresar usuario */}
          {step === 1 && (
            <div className="step-content">
              <form onSubmit={handleUsernameSubmit} className="step-form">
                <div className="input-group">
                  <label htmlFor="username">Nombre de Usuario</label>
                  <div className="input-wrapper">
                    <input
                      type="text"
                      id="username"
                      placeholder="Ingresa tu nombre de usuario"
                      value={username}
                      onChange={(e) => setUsername(e.target.value.toUpperCase())}
                      disabled={isLoading}
                      className={error ? "error" : ""}
                      required
                    />
                    <span className="input-icon"></span>
                  </div>
                </div>

                {/* Loading Progress Bar */}
                {isLoading && (
                  <div className="loading-container">
                    <div className="loading-info">
                      <div className="loading-text">
                        <span className="loading-icon">🔍</span>
                        <span>Buscando usuario en el sistema...</span>
                      </div>
                      <div className="loading-percentage">{Math.round(loadingProgress)}%</div>
                    </div>
                    <div className="progress-bar-container">
                      <div className="progress-bar-bg">
                        <div className="progress-bar-fill" style={{ width: `${loadingProgress}%` }}></div>
                      </div>
                    </div>
                    <div className="loading-steps">
                      <div className={`loading-step ${loadingProgress > 20 ? "completed" : "active"}`}>
                        <span className="step-dot"></span>
                        <span>Conectando al servidor</span>
                      </div>
                      <div
                        className={`loading-step ${loadingProgress > 60 ? "completed" : loadingProgress > 20 ? "active" : ""}`}
                      >
                        <span className="step-dot"></span>
                        <span>Verificando usuario</span>
                      </div>
                      <div
                        className={`loading-step ${loadingProgress > 90 ? "completed" : loadingProgress > 60 ? "active" : ""}`}
                      >
                        <span className="step-dot"></span>
                        <span>Obteniendo información</span>
                      </div>
                    </div>
                  </div>
                )}

                <button
                  type="submit"
                  className={`submit-button ${isLoading ? "loading" : ""}`}
                  disabled={isLoading || !username.trim()}
                >
                  {isLoading ? (
                    <>
                      <span className="spinner"></span>
                      Buscando usuario...
                    </>
                  ) : (
                    <>
                      <span className="button-icon">🔍</span>
                      Buscar Usuario
                    </>
                  )}
                </button>
              </form>
            </div>
          )}

          {/* Paso 2: Confirmar correo */}
          {step === 2 && (
            <div className="step-content">
              <div className="success-alert">
                <span className="alert-icon">✅</span>
                <div>
                  <h4>¡Usuario encontrado!</h4>
                  <p>Confirma tu dirección de correo electrónico para continuar.</p>
                </div>
              </div>

              <div className="email-confirmation">
                <div className="email-display">
                  <span className="email-icon"></span>
                  <span className="button-icon">

                  </span>

                  <div className="email-info">
                    <p className="email-label">Enviar correo de recuperación a:</p>
                    <p className="email-address">{userEmail}</p>
                  </div>
                </div>
              </div>

              <div className="button-group">
                <button
                  onClick={handleSendToken}
                  className={`submit-button ${isLoading ? "loading" : ""}`}
                  disabled={isLoading}
                >
                  {isLoading ? (
                    <>
                      <span className="spinner"></span>
                      Enviando...
                    </>
                  ) : (
                    <>
                      <span className="button-icon">📤</span>
                      Enviar Correo
                    </>
                  )}
                </button>

                <button onClick={resetForm} className="secondary-button" disabled={isLoading}>
                  <span className="button-icon">←</span>
                  Volver
                </button>
              </div>
            </div>
          )}

          {/* Paso 3: Mensaje final */}
          {step === 3 && (
            <div className="step-content">
              {message && (
                <div className="success-message">
                  <span className="message-icon">✅</span>
                  <div>
                    <h4>¡Correo enviado exitosamente!</h4>
                    <p>{message}</p>
                  </div>
                </div>
              )}

              <div className="instructions-box">
                <h4>📋 ¿Qué hacer ahora?</h4>
                <div className="instructions-list">
                  <div className="instruction-item">
                    <span className="instruction-number">1</span>
                    <span>Revisa tu bandeja de entrada</span>
                  </div>
                  <div className="instruction-item">
                    <span className="instruction-number">2</span>
                    <span>Verifica la carpeta de spam o correo no deseado</span>
                  </div>
                  <div className="instruction-item">
                    <span className="instruction-number">3</span>
                    <span>Haz clic en el enlace del correo</span>
                  </div>
                  <div className="instruction-item">
                    <span className="instruction-number">4</span>
                    <span>Sigue las instrucciones para crear tu nueva contraseña</span>
                  </div>
                </div>
              </div>

              <div className="final-actions">
                <button
                  onClick={() => (window.location.href = ambiente === "paco2"
                    ? "https://sitio1.paco.com.co/"
                    : "https://apps.paco.com.co/inicio/paco/login")}
                  className="secondary-button full-width"
                >
                  <span className="button-icon">🔄</span>
                  Terminar
                </button>
              </div>
            </div>
          )}

          {/* Mensajes de error */}
          {error && step !== 3 && (
            <div className="error-message">
              <span className="error-icon">⚠️</span>
              <div>
                <h4>Error</h4>
                <p>¡Ups! No encontramos ningún usuario que coincida con la información ingresada.</p>
              </div>
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="card-footer">
          <p style={{ color: "grey" }}>
            ¿Necesitas ayuda?{" "}
            <a href="https://paco.freshdesk.com/support/tickets/new" className="support-link">
              Contacta soporte
            </a>
          </p>
        </div>
      </div>
    </div>
  )
}

export default ForgotPassword
